import React, { useState } from 'react';
import Header from '../header/header';
import Sidebar from '../sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './Layout.css';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="layout-container">
      <Header toggleSidebar={toggleSidebar} />
      <div className="layout-main">
        <Sidebar isOpen={isSidebarOpen} setisOpen={setIsSidebarOpen} />
        
        {/* Overlay for mobile when sidebar is open */}
        {isSidebarOpen && (
          <div 
            className="mobile-overlay"
            onClick={() => setIsSidebarOpen(false)}
          ></div>
        )}

        <main className="content-area">
          <AnimatePresence mode="wait">
            <motion.div
              key={window.location.pathname}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              className="page-content"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
};

export default Layout;
